"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAccordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var Icon_1 = require("../Icon");
var Tooltip_1 = require("../Tooltip");
var Panel_1 = require("../Panel");
var react_animate_height_1 = __importDefault(require("react-animate-height"));
var UiAction_1 = require("../../uiAction/UiAction");
var IconSymbols_1 = require("../../generated/IconSymbols");
var SimpleAccordion = /** @class */ (function (_super) {
    __extends(SimpleAccordion, _super);
    function SimpleAccordion(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleActive = function () {
            _this.setState({
                isActive: !_this.state.isActive
            });
        };
        _this.state = {
            isActive: _this.props.isActive ? true : false
        };
        return _this;
    }
    SimpleAccordion.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, id = _a.id, header = _a.header, children = _a.children, actions = _a.actions;
        var isActive = this.state.isActive;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ id: id, className: "simple-accordion ".concat(className || ""), "data-active": isActive }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container-fluid" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "row" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "col" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "d-flex align-items-center py-3" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "simple-accordion__icon", onClick: this.toggleActive }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: IconSymbols_1.IconSymbols.ChevronDown }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "simple-accodian__header", style: { flexGrow: 1 } }, { children: header })), actions ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "simple-accordion__actions" }, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ position: Tooltip_1.TooltipPositions.LEFT, shownElement: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: IconSymbols_1.IconSymbols.DotsHorizontal }), triggeredOn: "click", className: "float-right" }, { children: (0, jsx_runtime_1.jsx)(Panel_1.Panel, __assign({ background: Panel_1.PanelBackgrounds.BG_WHITE, style: { width: "140px" }, hasShadow: true }, { children: actions.map(function (action) { return ((0, jsx_runtime_1.jsx)(UiAction_1.UiActionComponent, { action: action, contextModel: _this }, action.id)); }) })) })) }))) : null] })) })) })) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "simple-accordion__children" }, { children: (0, jsx_runtime_1.jsx)(react_animate_height_1.default, __assign({ height: isActive ? "auto" : 0 }, { children: children })) }))] }));
    };
    return SimpleAccordion;
}(react_1.default.Component));
exports.SimpleAccordion = SimpleAccordion;
